<template>
    <div class="form-container">
        <div class="white-box" v-loading="loading">
            <div class="title">
                请选择参赛形式
            </div>
            <div class="personal-box">
                <!-- <div :class="['personal','']"  v-for="item,index in rounds" :key="item.round_id" @click="change(index)"> -->
                <div v-for="item,index in rounds" :key="item.round_id" :class="[`${radio == index ? 'selectKey personal' : 'personal'}`,'']"  @click="change(index)">
                    <el-radio v-model="radio" :label="index" :class="[`${radio == index ? 'now' : ''}`,'']">{{item.round_name}}</el-radio>
                    <img v-if="radio == index" :src="item.img_active" alt="">
                    <img v-else :src="item.img" alt="">
                </div>
            </div>
            <el-button class="form-btn" @click="next">确定</el-button>
        </div>
    </div>
</template>

<script>
import '../../assets/css/form.css'
import {
    apiGetRounds
} from '../../plugins/apis'
export default {
  data () {
    return {
        radio:0,
        rounds:[],
        loading:true,
    }
  }, 
  // 组件方法
  async mounted () {
      await this.getRounds()
      this.loading = false
      
  },
  
  methods: {
    next(){
        if(this.radio === ''){
            this.$message.error('请选择赛制')
            return
        }
        let _round = this.rounds[this.radio]
        window.localStorage.setItem('round_info',JSON.stringify(_round))
        this.$router.push(`/`)
    },
    change(index){
        this.radio = index;   
    },
    async getRounds(){
        let res = await apiGetRounds()
        if(res.code === 200){
            for(let item of res.data){
                item.img = require(`../../assets/images/form/${item.round_id}.png`)
                item.img_active = require(`../../assets/images/form/${item.round_id}-on.png`)
            }
            this.rounds = res.data
            console.log(this.rounds);
            if(this.rounds.length <= 1){
                window.localStorage.setItem('round_info',JSON.stringify(this.rounds[0]))
                this.$router.push(`/`)
            }
        }
    }
  },
}
</script> 

<style scoped>
.personal:hover{
    border-color: #733085;
}
.personal:hover .el-radio__inner{
    border-color: #733085 !important;
}
.selectKey{
    border-color: #733085 !important;
}
.now{
    font-weight: 600;
}
</style>
